module.exports = __webpack_public_path__ + "static/img/success_icon.294203e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteJob/success_icon.png
// module id = yUSy
// module chunks = 34